export default{
  return_return:'Return',
  // daily
  return_dailyreturnusers:'Daily Return Users',
  return_dailyreturnusersdetails:'Daily Return Users Details',
  return_dailyreturnusersTable:'Daily Return Users',
  return_dailyTableone:'Daily return = Daily active - Daily new - Daily retained',

  // weekly
  return_weeklyBiweeklyReturnUsers:'Weekly/Biweekly Return Users',
  return_weeklyReturnUsers:'Weekly Return Users',
  return_biweeklyReturnUsers:'Biweekly Return Users',
  return_weeklyBiweeklyReturnUsersDetail:'Weekly/Biweekly Return Users Details',
  return_weeklytableoneTip:'Weekly return = Weekly active - Weekly retained - Weekly new',
  return_weeklyTabletwoTip:'Bieekly return = Bieekly active - Bieekly retained - Biweekly new',
  // monthly
  return_monthlyReturnUsers:'Monthly Return Users',
  return_monthlyReturnUsersDetail:'Monthly Return Users Details',
  return_monthlyTableoneTip:'',
  return_thisMonth:'This Month',
  return_lastYear:'Last Year',


  return_data:'Date',
  return_countryregionzonebreakdown:'Country/Region/Zone Breakdown',
  return_returnoftop10country:'Return of Top 10 Countries',
  return_returnoftop10Regions:'Return of Top 10 Regions',
  return_returnoftop10zones:'Return of Top 10 Zones',

  return_returnoftop10platform:'Return of Platform',
  return_returnoftop10language:'Return of Language',

  return_sumreturn:'Sum Return',
  return_shareofall:'Share of All',
  return_country:'Country',
  return_region:'Region',
  return_zone:'Zone',
  return_system:'Platform',
  return_language:'Language',
  return_records:'records',
  
  return_today:'Today',
  return_SDLW:'SDLW',

  return_Sum_Retrun:'Sum Return'


}
